var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import { VisuallyHidden } from './VisuallyHidden';
import { isSameContent } from '../utils';
export var defaultProps = {
    role: 'log',
    setting: 'polite',
    ariaAtomic: 'false',
};
var LiveRegion = React.memo(function (_a) {
    var announcementIndex = _a.announcementIndex, announcement = _a.announcement, role = _a.role, setting = _a.setting, ariaAtomic = _a.ariaAtomic, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, others = __rest(_a, ["announcementIndex", "announcement", "role", "setting", "ariaAtomic", "ariaLabelledBy", "ariaDescribedBy"]);
    /**
     * Using `myAnnouncement` to prevent situations where the live region does
     * not update because the text and attributes haven't changed. What we're
     * doing instead is responding to the `announcementIndex` change and
     * forcing a text change to '' and back to the requested `announcement`
     * if that situation presents itself.
     */
    var _b = __read(useState(''), 2), myAnnouncement = _b[0], setMyAnnouncement = _b[1];
    useEffect(function () {
        if (isSameContent(announcement, myAnnouncement)) {
            setMyAnnouncement('');
        }
        else {
            setMyAnnouncement(announcement);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [announcementIndex]);
    useEffect(function () {
        if (myAnnouncement === '' && announcement !== '') {
            setMyAnnouncement(announcement);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myAnnouncement]);
    return (React.createElement(VisuallyHidden, __assign({ role: role, "aria-live": setting, "aria-relevant": "all", "aria-atomic": ariaAtomic, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }, others), myAnnouncement));
});
LiveRegion.defaultProps = defaultProps;
export { LiveRegion };
//# sourceMappingURL=LiveRegion.js.map